<template style="height:100%">
  <div class="Activity_offline">
    <div class="Activity_offline_top" style="padding:20px">
      <el-form  :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="活动主题">
          <el-input v-model="formInline.subject" placeholder="活动主题"></el-input>
        </el-form-item>
        <el-form-item label="活动日期">
          <el-date-picker v-model="formInline.subjectTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="活动类型">
          <el-select v-model="formInline.eventType" placeholder="活动区域">
            <el-option label="全部" value="0"></el-option>
            <el-option label="体验型" value="1"></el-option>
            <el-option label="治疗性" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="czSubmit">重置</el-button>
      </el-form>
      <!-- <span>活动类型：</span>
      <ul>
        <li @click="EventType_fun(0)">全部</li>
        <li @click="EventType_fun(1)">体验型</li>
        <li @click="EventType_fun(2)">治疗性</li>
      </ul> -->
    </div>
    <div style="height: 15px;width: 100%;background-color: rgb(235, 236, 237);"></div>
    <div class="Activity_offline_nav">
      <el-table v-loading="loadings" :data="tableData" :row-key="(row) => {return row.PaperResultID;}" style="width: 100%;" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
        <el-table-column label="活动主题" prop="subject" min-width="100" align="left"></el-table-column>
        <el-table-column prop="eventTypeStr" label="活动类型"></el-table-column>
        <el-table-column prop="eventRateStr" label="活动形式"></el-table-column>
        <el-table-column prop="eventLimitStr" label="活动对象" min-width="150"></el-table-column>
        <el-table-column label="活动人数" prop="signNum" width="200" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="createTime" width="300"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="open(scope.row)" size="small">查看</el-button>
            <el-button type="text" @click="fabu(scope.row)" size="small">发布</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next" :total="Counts">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="查看活动" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <ul class="lkjhl">
        <li>
          <span>活动主题：</span>
          <p>{{ fanxie.subject }}</p>
        </li>
        <li>
          <span>活动类型：</span>
          <p>{{ fanxie.eventType == 1?'体验型活动':'治疗性活动' }}</p>
        </li>
        <li>
          <span>举办形式：</span>
          <p>{{ fanxie.eventRate == 1 ? '单次' : '连续' }}</p>
        </li>

        <li>
          <span>举办时间：</span>
          <p>{{ fanxie.eventStartTime }}日 {{fanxie.eventStartTiming}} - {{ fanxie.eventEndTime }}日 {{fanxie.eventEndTiming}}</p>
        </li>

        <li>
          <span>报名时间：</span>
          <p>{{ fanxie.signStartTime }} - {{ fanxie.signEndTime }}</p>
        </li>

        <li>
          <span>活动地点：</span>
          <p>{{ fanxie.address }}</p>
        </li>

        <li>
          <span>活动对象：</span>
          <p>{{ fanxie.eventLimit == 1 ? '院内活动' : '外院联合活动'}}</p>
        </li>

        <li>
          <span>活动人数：</span>
          <p>{{ fanxie.signNum }}</p>
        </li>

        <li>
          <span>参加院系：</span>
          <p>
            <span style="margin-left: 20px;" v-for="(item,i) in fanxie.tged" :key="i">{{ item.deptName }}</span>
          </p>
        </li>

        <li>
          <span>活动内容：</span>
          <p>{{ fanxie.evenContent }}</p>
        </li>

        <li>
          <span>活动预算：</span>
          <p>{{ fanxie.eventBudget }}</p>
        </li>

        <li>
          <span>是否需要预报名：</span>
          <p>{{ fanxie.preSignFlg == 1 ? '需要预报名' : '不需要预报名' }}</p>
        </li>

        <li>
          <span>限制报名人数：</span>
          <p>{{ fanxie.preSignNum }}</p>
        </li>

        <li>
          <span>预报名筛选表：</span>
          <p>{{ fanxie.prePaperCode }}</p>
        </li>

        <li>
          <span>是否招募志愿者：</span>
          <p>{{ fanxie.volunteerFlg == 1 ? '招募志愿者' : '不招募志愿者'  }}</p>
        </li>

        <li>
          <span>志愿者人数：</span>
          <p>{{ fanxie.receiveNum }}</p>
        </li>

        <li>
          <span>活动负责人：</span>
          <p>{{ fanxie.chargePerson }}</p>
        </li>

        <li>
          <span>活动负责人电话：</span>
          <p>{{ fanxie.chargePersonPhone }}</p>
        </li>

        <li>
          <!-- syncChart -->
          <span>是否同步到论坛：</span>
          <p>{{ fanxie.syncChart == 1 ? '同步' : '不同步'  }}</p>
          <!-- <p>{{fanxie.SyncChart}}</p> -->
        </li>

        <li class="shenpi" style="height: 220px;">
          <h2 style="margin-top: 20px;">审批流程</h2>
          <p style="width: 96%;height: 60px;margin-top: 20px;margin-left: 2%;">
            辅导员：
            <span style="margin-left: 300px;display: inline-block;" v-if="fanxie.counselorAudit == 1">未审核</span>
            <span style="margin-left: 300px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.counselorAudit == 2">审核通过</span>
            <span style="margin-left: 300px;display: inline-block;color: red" v-else-if="fanxie.counselorAudit == 3">审核驳回</span>
            <span style="margin-left: 300px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.counselorAudit == 4">不需要审核</span>
            <span style="width: 40px;height: 40px;text-align: center;border-radius: 50%;background-color: #409EFF;text-align: center;line-height: 40px;display: inline-block;float: right;color: #fff;font-size: 12px;margin-top: -20px;">{{ fanxie.counselorName? fanxie.counselorName:'无' }}</span>
          </p>

          <p style="width: 96%;height: 60px;margin-left: 2%;">
            系主任：
            <span style="margin-left: 300px;display: inline-block;" v-if="fanxie.chairManAudit == 1">未审核</span>
            <span style="margin-left: 300px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.chairManAudit == 2">审核通过</span>
            <span style="margin-left: 300px;display: inline-block;color: red" v-else-if="fanxie.chairManAudit == 3">审核驳回</span>
            <span style="margin-left: 300px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.chairManAudit == 4">不需要审核</span>
            <span style="width: 40px;height: 40px;text-align: center;border-radius: 50%;background-color: #409EFF;text-align: center;line-height: 40px;display: inline-block;float: right;color: #fff;font-size: 12px;margin-top: -20px;">{{ fanxie.chairManName ? fanxie.chairManName : '无' }}</span>
          </p>

          <p style="width: 96%;height: 60px;margin-left: 2%;">活动管理员：
            <span style="margin-left: 286px;display: inline-block;" v-if="fanxie.psyCenterAudit == 1">未审核</span>
            <span style="margin-left: 286px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.psyCenterAudit == 2">审核通过</span>
            <span style="margin-left: 286px;display: inline-block;color: red" v-else-if="fanxie.psyCenterAudit == 3">审核驳回</span>
            <span style="margin-left: 286px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.psyCenterAudit == 4">不需要审核</span>
            <span style="width: 40px;height: 40px;text-align: center;border-radius: 50%;background-color: #409EFF;text-align: center;line-height: 40px;display: inline-block;float: right;color: #fff;font-size: 12px;margin-top: -20px;">{{ fanxie.psyCenterName ? fanxie.psyCenterName : '无' }}</span>
          </p>
            <!-- <li v-if="looklist.centerDirectorAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
              <span>心理中心主任：</span>
              <span style="position: absolute;left: 100px;width: 80px;color: #298FE8;" v-if="looklist.centerDirectorAudit == '1'">待审核</span>
              <span style="position: absolute;left: 100px;width: 80px;color: rgb(83 184 31);" v-if="looklist.centerDirectorAudit == '2'">审核通过</span>
              <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.centerDirectorAudit == '3'">审核拒绝</span>
              <span style="position: absolute;left: 100px;width: 80px;" v-if="looklist.centerDirectorAudit == '4'">无需审核</span>
              <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.centerDirectorAudit == '5'">审核驳回</span>
            </li> -->

          <p style="width: 96%;height: 60px;margin-left: 2%;">心理中心主任：
            <span style="margin-left: 260px;display: inline-block;" v-if="fanxie.centerDirectorAudit == 1">未审核</span>
            <span style="margin-left: 260px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.centerDirectorAudit == 2">审核通过</span>
            <span style="margin-left: 260px;display: inline-block;color: red" v-else-if="fanxie.centerDirectorAudit == 3">审核驳回</span>
            <span style="margin-left: 260px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.centerDirectorAudit == 4">不需要审核</span>
            <span style="margin-left: 260px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.centerDirectorAudit == 5">审核驳回</span>
          </p>

          <p style="width: 96%;height: 60px;margin-left: 2%;">校长：
            <span style="margin-left: 315px;display: inline-block;" v-if="fanxie.principalAudit == 1">未审核</span>
            <span style="margin-left: 315px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.principalAudit == 2">审核通过</span>
            <span style="margin-left: 315px;display: inline-block;color: red" v-else-if="fanxie.principalAudit == 3">审核驳回</span>
            <span style="margin-left: 315px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.principalAudit == 4">不需要审核</span>
            <span style="margin-left: 315px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.principalAudit == 5">审核驳回</span>
          </p>

            <!-- <div class="lookdiv">
              <h6>审批流程：</h6>
              <ul style="padding-bottom:40px">
                <li v-if="looklist.counselorAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
                  <span>辅导员：</span>
                  <span style="position: absolute;left: 100px; width: 80px;color: #298FE8;" v-if="looklist.counselorAudit == '1'">待审核</span>
                  <span style="position: absolute;left: 100px; width: 80px;color: rgb(83 184 31);" v-if="looklist.counselorAudit == '2'">审核通过</span>
                  <span style="position: absolute;left: 100px; width: 80px;color: rgb(228 80 46);" v-if="looklist.counselorAudit == '3'">审核拒绝</span>
                  <span style="position: absolute;left: 100px; width: 80px;" v-if="looklist.counselorAudit == '4'">无需审核</span>
                  <span style="position: absolute;left: 100px; width: 80px;color: rgb(228 80 46);" v-if="looklist.counselorAudit == '5'">审核驳回</span>
                </li>

                <li v-if="looklist.chairManAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
                  <span>系主任：</span>
                  <span style="position: absolute;left: 100px;width:80px;color: #298FE8;" v-if="looklist.chairManAudit == '1'">待审核</span>
                  <span style="position: absolute;left: 100px;width:80px;color: rgb(83 184 31);" v-if="looklist.chairManAudit == '2'">审核通过</span>
                  <span style="position: absolute;left: 100px;width:80px;color: rgb(228 80 46);" v-if="looklist.chairManAudit == '3'">审核拒绝</span>
                  <span style="position: absolute;left: 100px;width:80px;" v-if="looklist.chairManAudit == '4'">无需审核</span>
                  <span style="position: absolute;left: 100px;width:80px;color: rgb(228 80 46);" v-if="looklist.chairManAudit == '5'">审核驳回</span>
                </li>

                <li v-if="looklist.psyCenterAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
                  <span>心理中心：</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: #298FE8;" v-if="looklist.psyCenterAudit == '1'">待审核</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: rgb(83 184 31);" v-if="looklist.psyCenterAudit == '2'">审核通过</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.psyCenterAudit == '3'">审核拒绝</span>
                  <span style="position: absolute;left: 100px;width: 80px;" v-if="looklist.psyCenterAudit == '4'">无需审核</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.psyCenterAudit == '5'">审核驳回</span>
                </li>

                <li v-if="looklist.centerDirectorAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
                  <span>心理中心主任：</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: #298FE8;" v-if="looklist.centerDirectorAudit == '1'">待审核</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: rgb(83 184 31);" v-if="looklist.centerDirectorAudit == '2'">审核通过</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.centerDirectorAudit == '3'">审核拒绝</span>
                  <span style="position: absolute;left: 100px;width: 80px;" v-if="looklist.centerDirectorAudit == '4'">无需审核</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.centerDirectorAudit == '5'">审核驳回</span>
                </li>

                <li v-if="looklist.principalAudit !== '4'" style="width: 80%;margin-left: 10%;padding-top: 30px;border-bottom: 1px solid rgb(211 203 203);padding-bottom: 30px;position: relative;">
                  <span>校长：</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: #298FE8;" v-if="looklist.principalAudit == '1'">待审核</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: rgb(83 184 31);" v-if="looklist.principalAudit == '2'">审核通过</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.principalAudit == '3'">审核拒绝</span>
                  <span style="position: absolute;left: 100px;width: 80px;" v-if="looklist.principalAudit == '4'">无需审核</span>
                  <span style="position: absolute;left: 100px;width: 80px;color: rgb(228 80 46);" v-if="looklist.principalAudit == '5'">审核驳回</span>
                  <div style="width: 50px;height: 50px;position: absolute;right: 20px;top:14px;background-color: #298FE8;color: #fff;border-radius:50%;text-align:center; line-height: 50px;">{{ looklist.PrincipalName?looklist.PrincipalName:'无' }}</div>
                </li>
                
              </ul>
            </div> -->
        </li>
        <li>
          <el-button type="primary" style="margin-left: 45%;" @click="dialogVisible = false">确定</el-button>
        </li>
      </ul>
    </el-dialog>

    <el-dialog title="发布活动" :visible.sync="dialogVisibles" width="50%" :before-close="handleClose">
      <ul class="lkjhl">
        <li>
          <span>活动主题：</span>
          <p>{{ fanxie.Subject }}</p>
        </li>
        <li>
          <span>活动类型：</span>
          <p>{{ fanxie.EventType }}</p>
        </li>
        <li>
          <span>举办形式：</span>
          <p>{{ fanxie.EventRate }}</p>
        </li>
        <li>

          <span>举办时间：</span>
          <p>{{ fanxie.EventTime }}</p>

          <span @click="timexigai = !timexigai" style="color: rgba(0, 136, 255, 1);margin-left: 16px;">修改</span><br>


          <el-date-picker style="margin-top: 10px;margin-bottom: 10px;" @change="ccslkj" v-if="timexigai"
            v-model="xiugai.EventTime" type="datetimerange" value-format="yyyy-MM-dd hh:mm:ss" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>

        </li>
        <li>
          <span>报名时间：</span>
          <p>{{ fanxie.SignStartTime }}</p>

          <span @click="timesxigai = !timesxigai" style="color: rgba(0, 136, 255, 1);margin-left: 16px;">修改</span><br>

          <el-date-picker style="margin-top: 10px;margin-bottom: 10px;" v-if="timesxigai" v-model="xiugai.SignStartTim"
            value-format="yyyy-MM-dd hh:mm:ss" type="datetime" placeholder="选择日期时间">
          </el-date-picker>

        </li>
        <li>
          <span>活动地点：</span>
          <p>{{ fanxie.Address }}</p>

          <span @click="didianxigai = !didianxigai" style="color: rgba(0, 136, 255, 1);margin-left: 16px;">修改</span><br>

          <el-input style="margin-top: 10px;margin-bottom: 10px;" v-if="didianxigai" v-model="xiugai.Address">
          </el-input>

        </li>
        <li>
          <span>活动对象：</span>
          <p>{{ fanxie.EventLimit }}</p>
        </li>
        <li>
          <span>活动人数：</span>
          <p>{{ fanxie.SignNum }}</p>
        </li>
        <li>
          <span>参加院系：</span>
          <p>{{ fanxie.Tged }}</p>
        </li>
        <li>
          <span>活动内容：</span>
          <p>{{ fanxie.EvenContent }}</p>
        </li>
        <li>
          <span>活动预算：</span>
          <p>{{ fanxie.EventBudget }}</p>
        </li>
        <li>
          <span>是否需要预报名：</span>
          <p>{{ fanxie.Subject }}</p>
        </li>
        <li>
          <span>限制报名人数：</span>
          <p>{{ fanxie.PreSignFlg }}</p>
        </li>
        <li>
          <span>预报名筛选表：</span>
          <p>{{ fanxie.PrePaperCode }}</p>
        </li>
        <li>
          <span>是否招募志愿者：</span>
          <p>{{ fanxie.VolunteerFlg }}</p>
        </li>
        <li>
          <span>志愿者人数：</span>
          <p>{{ fanxie.OtherNum }}</p>
        </li>
        <li>
          <span>活动负责人：</span>
          <p>{{ fanxie.ChargePerson }}</p>
        </li>

        <li>
          <span>活动封面</span>
          <div class="cover" style="margin-left:-70px">
            <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action=""
              :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
              accept="image/jpeg,image/gif,image/png">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon">
                <span style="font-size: 16px;">点击选择封面</span>
              </i>
            </el-upload>
          </div>

        </li>

        <li>
          <span>是否同步到论坛：</span>
          <el-radio-group v-model="BBS">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
          <!-- <p>{{fanxie.SyncChart}}</p> -->
        </li>
        <li class="shenpi">
          <h2>审批流程</h2>
        </li>

        <li>
          <el-button @click="fabuurl()">
            发布
          </el-button>
        </li>
      </ul>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      file: '',
      imageUrl: '',
      EventNo: '',
      timexigai: false,
      timesxigai: false,
      didianxigai: false,
      BBS: '0',
      dialogVisible: false,
      dialogVisibles: false,
      loadings: false,
      tableData: [],
      content: "",
      fanxie: '',
      pageIndex: 1,
      Counts: 1,
      currentPage1: 1,
      xiugai: {
        EventTime: [],
        Address: "",
        SignStartTime: "",
        t: "",
        d: "",
        o: "",
        e: "",
        q: "",
      },
      formInline: {
        pageSize: 10,
        pageIndex: 1,
        holdType: 0,//举办方式 0代表线下发布或者立项  1代表自助活动 默认为0；
        eventType: '0',//活动类型 0全部 1全部 2全部 开始查询默认为2
        eventStatus: 3,//1-立项 2-审核中 3-审核通过 4-驳回修改 5-拒绝 6-发布
        subject: '',//活动主题
        subjectTime: '',//活动日期
        times: '',//创建时间（查询自助活动用）
      }
    };
  },
  components: {

  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleDelete(index, row) { },
    handleSizeChange(val) { },
    handleCurrentChange(val) {
      this.loading(val);
    },
    handleChange(file, fileList) {
      if (file.raw.type == "image/jpeg" || file.raw.type == "image/gif" || file.raw.type == "image/png") {
        this.imageUrl = URL.createObjectURL(file.raw)
        this.file = file
      }else {
        this.$message({
          type: 'error',
          message: "文件格式错误，请上传图片",
        })
      }
    },
    ccslkj() {
      // this.timedata.push(this.ruleForm.EventTime);

    },
    fabu(val) {
      this.EventNo = val
      var sxckl = {
        pageSize: '1',
        pageIndex: '1',
        EventNo: val,
      }
      this.$Http_Post("/activitymanagement/publishofflineevent", //获取发布对象
        { eventKey: val.eventKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    fabuurl() {
      var from = new FormData()
      from.append('SXfb', "0")
      from.append('EventNo', this.EventNo) //发布主题
      from.append('SyncChar', this.BBS) //发布主题
      from.append('Subject', this.fanxie.Subject) //发布主题
      from.append('EvenContent', this.fanxie.EvenContent) //发布主题
      from.append('Classification', this.fanxie.Classification) //发布主题
      from.append('SpName', this.fanxie.SpName) //发布主题
      from.append('ContinueType', this.fanxie.ContinueType) //发布主题
      from.append('SignEndTime', this.fanxie.SignEndTime) //发布主题
      from.append('EventTime', this.xiugai.EventTime) //发布主题
      from.append('Address', this.xiugai.Address) //发布主题
      from.append('SignStartTime', this.xiugai.SignStartTime) //发布主题
      from.append('fl', this.file.raw) //封面
      from.append('fl2', '') //封面
      
      this.$Http_Post('ActivityManagement/EventFb', from, {
        'Content-Type': 'multipart/form-data',
      })
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {

          } else {
            this.Global.request_failure(res.Message)
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          })
        })
    },
    EventType_fun(val) {
      this.formInline.eventType = val;
      this.formInline.pageIndex = 1
      this.loading();
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    onSubmit() {
      this.formInline.pageIndex = 1
      this.loading();
    },
    czSubmit(){
      this.formInline.subject = ''
      this.formInline.subjectTime = ''
      this.formInline.eventType = '0'
      this.formInline.pageIndex = 1
      this.loading();
    },
    handleDelete(index, row) { },
    handleSizeChange(val) { },
    handleCurrentChange(val) {
      // this.loading(val);
    },
    open(a, b) {
      var sxckl = {
        eventKey: a.eventKey,
      }
      this.$Http_Post("/activitymanagement/fxeventplan", //获取发布对象
        { from: sxckl }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dialogVisible = true
          this.fanxie = res.Data
          BBS = fanxie.SyncChart
        } else {
        }
      })
    },
    loading(num) {
      this.loadings = true;
      this.$Http_Post("/activitymanagement/geteventplanlist",//获取发布对象
        { from: this.formInline }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.loadings = false;
            this.tableData = res.Data;
            this.Counts = Number(res.Counts);
          } else {
            this.loadings = false;
            this.Global.request_failure(res.Message);
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message,
          });
        });
    },
  },
  mounted() {
    this.loading(1);
  },
};
</script>
<style>
.Activity_offline{width: 100%;height: 100%;background-color: #fff;}
.Activity_offline_top {height: 60px;background-color: #fff;width: 100%;}
/* .Activity_offline_nav{width: 100%;height: 100%;background-color: #fff;} */
.Activity_offline_top .el-form--inline .el-form-item {margin-left: 20px;}
.Activity_offline .el-input__icon{margin-left:0px !important;}

/* .Activity_offline_top .el-date-editor.el-input, .el-date-editor.el-input__inner span {
  margin-left: 15px;
  float: left;
} */

.Activity_offline_top li {float: left;margin-left: 14px;cursor: pointer}
.lkjhl li {width: 100%;min-height: 50px;}
.lkjhl li>span {float: left;}
.lkjhl li p {float: left;}

.lkjhl .shenpi {
  border-top: 1px solid #000;
}

.Activity_offline .cover {
  margin-left: 10px;
  font-size: 14px;
  vertical-align: middle;
  box-sizing: border-box;
  position: relative;
  color: #606266;
  height: 175px;
}

.Activity_offline .avatar-uploader {
  position: absolute;
  top: 0px;
  left: 70px;
}

.Activity_offline .cover p {
  font-size: 14px;
  color: rgba(158, 158, 158, 1);
  position: absolute;
  top: 0px;
  left: 297px;
  width: 350px;
}

.Activity_offline .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin-left: 70px;
  overflow: hidden;
}

.Activity_offline .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.Activity_offline .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 215px;
  height: 148px;
  line-height: 148px;
  text-align: center;
  border: 1px solid #d1d1d1;
}
.Activity_offline .el-input__icon{margin-left: -10px;}
</style>